export enum MutationTypes {
    SET_REQUESTS = 'organisation-requests-module/set-requests',
    SET_REQUESTS_META = 'organisation-requests-module/set-requests-meta',
}
